import { formatDateToYMD } from "@utils/format.date";

import type { Customer } from "../../model/customer.model";
import type { FormikInitialValuesNewRequest } from "../../model/form.model";
import type { CartItem } from "../../model/product.cart.model";

import { ICreateOrderDTO } from "@modules/orders/dtos/ICreateOrderDTO";

export function toCreateOrderPayload(args: {
  values: FormikInitialValuesNewRequest;
  customer: Customer;
  cart: CartItem[];
}): ICreateOrderDTO {
  const { values, customer, cart } = args;

  const addressId = values.purchase.deliveryAddressId;
  if (!addressId) {
    throw new Error("Endereço de entrega não informado.");
  }

  const withdrawBasisId = values.purchase.withdrawBasisId;
  const wb = customer.withdrawBasis.find(
    (w) => String(w.shippingPoint) === String(withdrawBasisId)
  );

  if (!wb) {
    throw new Error(
      "Base de retirada inválida (withdrawBasisId não encontrado)."
    );
  }

  return {
    customer: {
      CNPJ: customer.cnpj,
      id: customer.id,
      distributionChannel: customer.distributionChannel,
      division: customer.division,
    },

    address: {
      id: addressId,
    },

    filialID: wb.filialID,
    withdrawBasisID: wb.shippingPoint,

    freightType: values.purchase.freightType,

    deliveryDate: formatDateToYMD(values.purchase.deliveryDate),

    comments: values.observation.observationNote || undefined,
    includeCommentsInInvoice: values.observation.commentsInInvoice,

    products: cart.map((item) => ({
      id: item.productId,
      deadlinePayment: Number(item.deadlinePayment),
      payment: item.payment,
      quantity: Number(item.quantity),
    })),
  };
}
